// 预设的用户列表
export const authorizedUsers = [
  // 管理员账号
  { username: 'admin001', password: 'P@558907', role: 'admin' },
  { username: 'admin002', password: 'Wy5@hL7$xM4', role: 'admin' },
  
  // 普通用户账号
  { username: 'user001', password: 'Qn9#pR4$mB6', role: 'user' },
  { username: 'user002', password: 'Zt5@jH8$cL3', role: 'user' },
  { username: 'user003', password: 'Fx7#kM2$nV9', role: 'user' },
  { username: 'user004', password: 'Hd4@wP6$yT8', role: 'user' },
  { username: 'user005', password: 'Bm3#sL9$rK5', role: 'user' },
  { username: 'user006', password: 'Vg8@nC4$tH7', role: 'user' },
  { username: 'user007', password: 'Jp5#xQ7$wM2', role: 'user' },
  { username: 'user008', password: 'Ry6@kF8$bN4', role: 'user' },
  { username: 'user009', password: 'Lc9#mH3$sP7', role: 'user' },
  { username: 'user010', password: 'Td7@wK5$xB8', role: 'user' },
  { username: 'user011', password: 'Gq4#vM9$cR2', role: 'user' },
  { username: 'user012', password: 'Xn8@hT6$pL5', role: 'user' },
  { username: 'user013', password: 'Yw2#jF7$mK9', role: 'user' },
  { username: 'user014', password: 'Ub5@sC8$vH4', role: 'user' },
  { username: 'user015', password: 'Pm7#nR2$wQ6', role: 'user' },
  { username: 'user016', password: 'Kd9@xL4$tB8', role: 'user' },
  { username: 'user017', password: 'Zc3#kH7$yM5', role: 'user' },
  { username: 'user018', password: 'Wf8@pT2$nV6', role: 'user' },
  { username: 'user019', password: 'Qj5#mB9$sR4', role: 'user' },
  { username: 'user020', password: 'Hx7@wL3$cK8', role: 'user' },
  { username: 'user021', password: 'Vt4#yF6$pM2', role: 'user' },
  { username: 'user022', password: 'Bg8@nQ5$xH7', role: 'user' },
  { username: 'user023', password: 'Lr2#sC9$wT4', role: 'user' },
  { username: 'user024', password: 'Mk6@jP7$vB8', role: 'user' },
  { username: 'user025', password: 'Dn9#kR4$yL5', role: 'user' },
  { username: 'user026', password: 'Xc7@mH2$tQ8', role: 'user' },
  { username: 'user027', password: 'Gw5#pF8$nK3', role: 'user' },
  { username: 'user028', password: 'Yb4@sM6$xV9', role: 'user' }
];

// 验证用户登录
export const validateUser = (username, password) => {
  const user = authorizedUsers.find(
    u => u.username === username && u.password === password
  );
  return user || null;
}; 